module.exports = __webpack_public_path__ + "img/up_a.0e005085.png";